/*
 * @Author: mayanxia 
 * @Date: 2022-01-17 14:26:02 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-03-11 12:08:42
 */


<!--批量导入界面-->
<template>
  <a-modal
    :title="$t('操作')"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    :maskClosable="maskClosable"
    @ok="handleOk"
    @cancel="handleCancel"
    
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <div style="margin-bottom: 20px">
        
      </div>
      <div>
        <a-row :gutter="24">
          <a-form-model ref="formModal" :model="formModel" :rules="rules" :colon="false">
              <a-col :span="24">
                <a-form-model-item :label="$t('批量方式')">
                    <a-radio-group  v-model="formModel.batchType">
                        <a-radio :value="1">
                            {{ $t('按区域导入') }}
                        </a-radio>
                        <a-radio :value="3">
                            {{ $t('按Excel导入') }}
                        </a-radio>
                        </a-radio-group>
                </a-form-model-item>
              </a-col>
            <a-col :span="12" v-if="formModel.batchType === 1">
                <a-form-model-item :label="$t('所选区域')">
                    <a-input-search
                        style="width: 90%"
                        :placeholder="$t('点击选择区域')"
                        v-model="checkedAreaNameString"
                        readOnly
                        @search="onSearchArea">
                        <a-button slot="enterButton" icon="search">{{ $t('选择') }}</a-button>
                    </a-input-search>
                </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="formModel.batchType === 3">
                <a-form-model-item :label="$t('上传文件')">
                    <a-upload name="file" 
                        :multiple="false" 
                        accept=".xls"
                        :fileList="fileList" 
                        :headers="tokenHeader"
                        :beforeUpload="beforeUpload"
                        :remove="handleRemove"
                        > 
                        <a-button>
                            <a-icon type="upload" />
                            {{ $t('选择导入文件') }}
                        </a-button>
                    </a-upload>
                </a-form-model-item>
            </a-col>
            <a-col :xl="8" :lg="7" :md="8" :sm="24">
                <a-form-model-item :label="$t('任务名称')" prop="taskName">
                    <a-input :placeholder="$t('请输入任务名称')" v-model="formModel.taskName"></a-input>
                </a-form-model-item>
            </a-col>
            <a-col :xl="24" :lg="24" :md="24" :sm="24">
                <a-form-model-item :label="$t('描述')" prop="remark">
                    <a-textarea v-model="formModel.remark" rows="2" :placeholder="$t('请输入备注')" style="width:100%"/>
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item :label="$t('旧价格信息')" prop="oldPriceId">
                    <a-select v-model="formModel.oldPriceId" :placeholder="$t('请选择用户价格名称')" @change="changeOldPrice"
                        :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <a-select-option v-for="data in userPriceList" :key="data.id" :value="data.id">
                            <a-tooltip>
                                <template slot="title">
                                {{ $t('单价:') }}{{data.wtTotalPrice/100}}{{ $t('元') }}
                                </template>
                                {{data.wtName}}
                            </a-tooltip>
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item :label="$t('新价格信息')" prop="newPriceId">
                    <a-select v-model="formModel.newPriceId" :placeholder="$t('请选择用户价格名称')" @change="changeNewPrice"
                        :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <a-select-option v-for="data in userPriceUnDisableList" :key="data.id" :value="data.id">
                            <a-tooltip>
                                <template slot="title">
                                {{ $t('单价:') }}{{data.wtTotalPrice/100}}{{ $t('元') }}
                                </template>
                                {{data.wtName}}
                            </a-tooltip>
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item :label="$t('启用日期')" prop="startDate">
                  <a-date-picker
                    dropdownClassName="j-date-picker"
                    :placeholder="$t('请选择启用日期')"
                    v-model="formModel.startDate"
                    :disabled-date="disabledDate"
                    :format="dateFormat"
                  />
                  <!--
                    <j-date placeholder="请选择启用日期" v-model="formModel.startDate" :trigger-change="true" style="width:100%"/>
                  -->
                </a-form-model-item>
            </a-col>
            <a-col :span="8">
                <a-form-model-item :label="$t('变更方式')" prop="changeWay">
                    <a-select  v-model="formModel.changeWay" :placeholder="$t('请选择')">
                        <a-select-option :value="1">
                        {{ $t('立即结算') }}
                        </a-select-option>
                        <a-select-option :value="2">
                        {{ $t('扣完再启用新价格') }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-col>
          </a-form-model>
        </a-row>
        <a-row>
            <a-collapse v-model="activeKey">
                <a-collapse-panel key="1" :header="$t('旧价格信息')">
                    <detail-list :span="24" v-if="formModel.oldPriceId">
                        <detail-list-item :term="$t('价格编码')">{{oldPriceInfo.wtCode}}</detail-list-item>
                        <detail-list-item :term="$t('价格名称')">{{oldPriceInfo.wtName}}</detail-list-item>
                        <detail-list-item :term="$t('单价总计')">{{oldPriceInfo.wtTotalPrice/100}}({{ $t('元/m³') }})</detail-list-item>
                        <detail-list-item :term="$t('计费类型')">{{oldPriceInfo.wtFeeType_dictText ? $t(oldPriceInfo.wtFeeType_dictText) : oldPriceInfo.wtFeeType_dictText}}</detail-list-item>
                        <detail-list-item :term="$t('阶梯数量')">{{oldPriceInfo.wtStepNum}}</detail-list-item>
                        <detail-list-item :term="$t('附加费总计')">{{oldPriceInfo.wtTotalChargePrice?oldPriceInfo.wtTotalChargePrice/100:''}}({{ $t('元/m³') }})</detail-list-item>
                    </detail-list>
                </a-collapse-panel>
                <a-collapse-panel key="2" :header="$t('新价格信息')" :disabled="false">
                    <detail-list :span="24" v-if="formModel.newPriceId">
                        <detail-list-item :term="$t('价格编码')">{{newPriceInfo.wtCode}}</detail-list-item>
                        <detail-list-item :term="$t('价格名称')">{{newPriceInfo.wtName}}</detail-list-item>
                        <detail-list-item :term="$t('单价总计')">{{newPriceInfo.wtTotalPrice/100}}({{ $t('元/m³') }})</detail-list-item>
                        <detail-list-item :term="$t('计费类型')">{{newPriceInfo.wtFeeType_dictText ? $t(newPriceInfo.wtFeeType_dictText) : newPriceInfo.wtFeeType_dictText}}</detail-list-item>
                        <detail-list-item :term="$t('阶梯数量')">{{newPriceInfo.wtStepNum}}</detail-list-item>
                        <detail-list-item :term="$t('附加费总计')">{{newPriceInfo.wtTotalChargePrice?newPriceInfo.wtTotalChargePrice/100:''}}({{ $t('元/m³') }})</detail-list-item>
                    </detail-list>
                </a-collapse-panel>
            </a-collapse>
        </a-row>
      </div>
      <div>
        <a-row :gutter="24" style="margin-top: 10px">
          <a-col :span="10">
            <a-button v-if="formModel.batchType === 3" type="link" icon="download" @click="downloadFormWork($t('批量调价模板'))">{{ $t('下载模板') }}</a-button>
          </a-col>
          <a-col :span="4">
            <a-button @click="handleSubmit()" type="primary">
              {{ $t('批量导入') }}
            </a-button>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <area-window ref="areaWindow" @ok="modalAreaFormOk"></area-window>
  </a-modal>
</template>

<script>
  import { listSize,paramsToFormData } from '@/utils/util'
  import { getAction,postAction } from '@/api/manage'
  import {queryAreaTreeList} from '@/api/api';
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import {fileUrl} from'@/utils/util'
  import JDate from '@/components/jeecg/JDate'
  import Vue from 'vue'
  import moment from 'moment';
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  // 引入搜索区域弹出框的组件
import areaWindow from '@/views/system/modules/areaWindow'
  const data = [];
  export default {
    name: 'MeterUserBatchAdjustPriceModal',
    components: {
        areaWindow,
        JDate,
        DetailList,
        DetailListItem,
    },
    data () {
      return {
        data,
        title:this.$t("操作"),
        visible: false,
        disableSubmit:false,
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        maskClosable:false,
        model: {},
        confirmLoading: false,

        url: {
          add: "/jeecg-charge/meter/meterPriceChangeRecord/doChangePriceTask",
          userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",
          importExcelUrl: "jeecg-charge/meter/meterBatchTaskRecord/batchAddMeterByExcel",//导入
        },
        fileList: [],
        formModel: {batchType: 1},
        oldPriceInfo: {},
        newPriceInfo: {},
        userPriceList: [],
        userPriceUnDisableList: [],
        checkedAreaKeys:[],
        halfCheckedAreaKeys: [],
        checkedAreaNameString:"",
        treeData: [],
        checkedAreaNames: [],
        activeKey: [],
        dateFormat:"YYYY-MM-DD",
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      rules() {
        return {
          taskName:[{ required: true, message: this.$t('请输入任务名称')}],
          oldPriceId: [{required: true, message: this.$t('请选择旧价格信息!')}],
          newPriceId: [{required: true, message: this.$t('请选择新价格信息!')}],
          startDate: [{required: true, message: this.$t('请选择价格启用日期!')}],
          changeWay: [{required: true, message: this.$t('请选择变更方式!')}],
        }
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    created () {
      
    },
    methods: {
      moment,
      disabledDate(current) {
        // Can not select days before today and today
        //return current && current <= moment().endOf('day');

        // 只能选择今日及后边的日期
        return current && current < moment().subtract(1, 'days').endOf('day')
      },
      getUserPriceList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          console.log(res)
          if(res.success){
            this.userPriceList = res.result.records;
            let unDisableList = [];
            for(var i=0;i<this.userPriceList.length;i++) {
              if(this.userPriceList[i].statusDisable===0) {
                unDisableList.push(this.userPriceList[i])
              }
            }
            // 新价格是启用状态的
            this.userPriceUnDisableList = unDisableList;
          }
        })
      },
      handleSubmit() {
        const { fileList } = this;
        // 触发表单验证
        if(this.formModel.batchType===1&&this.checkedAreaKeys.length===0) {
            // 按区域批量下发命令
            this.$message.error(this.$t("请先选择区域"))
            return
        }/*else if(this.formModel.batchType===2&&(isUndefinedAndNull(this.formModel.meterIdList)||this.formModel.meterIdList.length===0)) {
            this.$message.error("请先选择表号")
            return
        }*/else if(this.formModel.batchType===3&&fileList.length===0) {
            this.$message.error(this.$t("请先上传excel文件"))
            return
        }
        this.$refs.formModal.validate(valid => {
          if(valid) {
            this.handleUpload()
          }else{
            return false
          }
        })
      },
      handleUpload() {
        this.confirmLoading = true
        let formData = new FormData();
        let params = Object.assign({}, this.formModel);
        params.startDate = moment(this.formModel.startDate).format(this.dateFormat)
        formData = paramsToFormData(params);
        console.log(this.formModel)
        if(this.formModel.batchType===1) {
            // 按区域批量下发命令
            if(this.checkedAreaKeys.length===0) {
                this.$message.error(this.$t("请先选择区域"))
                return
            }
            formData.append('areaIdList', [...this.checkedAreaKeys].join(","))
            formData.set('taskName',this.formModel.taskName+this.$t('(按区域)'))
        }/*else if(this.formModel.batchType===2) {
            formData.append('meterIdList',this.model.meterIdList)
            formData.set('taskName',this.taskModel.taskName+'(按表号)')
        }*/else if(this.formModel.batchType===3) {
            const { fileList } = this;
            if(fileList.length==0) {
                this.$message.error(this.$t("请先上传excel文件"))
                return
            }
            fileList.forEach((file) => {
                formData.append('file', file);
            });
            formData.set('taskName',this.formModel.taskName+this.$t('(按Excel)'))
        }
        
        postAction(this.url.add, formData).then((res) => {
          this.confirmLoading = false
          if(res.success&&res.code == 0){
            this.$message.success(this.$t("添加成功,请至【辅助服务--批量任务列表】去查看执行结果"))
            this.$emit('ok')
            this.close()
          }else{
            this.$message.warning(res.message)
          }
        })
        
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        // 只支持Excel,
        let fileName = file.name;
        let fileType = fileName.substring(fileName.lastIndexOf("."),fileName.length);
        if(fileType!='.xls') {
          this.$message.error(this.$t("只支持.xls格式文件！"))
          return false;
        }else{
          this.fileList = [file];
          return false;
        }
      },
      add() {
        this.edit({});
      },
      edit (record) { 
        console.log("编辑")
        this.visible = true;
        this.getUserPriceList();
        this.queryAreaTree();
      },
      handleOk(){},
      shut(){
        this.model = this.$options.data.call(this).model
        this.formModel = this.$options.data.call(this).formModel
        this.$refs.formModal.resetFields()
        this.activeKey = this.$options.data.call(this).activeKey
        this.fileList = []
        this.oldPriceInfo= {};
        this.newPriceInfo = {};
        this.userPriceList = [];
        this.checkedAreaKeys = [];
        this.halfCheckedAreaKeys = [];
        this.checkedAreaNameString = "";
        this.checkedAreaNames = []

      },
      close () {
        this.$emit('close');
        this.shut();
        this.disableSubmit = false;
        this.visible = false;
        
      },
      downloadFormWork(fileName) {
        console.log("下载批量报装模板")
        let deviceFileUrl = '/file/common_user_model.xls'
        let url = `${fileUrl}${deviceFileUrl}`
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        console.log(fileName)
        link.setAttribute('download', fileName+'.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(link.href); //释放掉blob对象
      },
      handleCancel () {
        this.close();
      },
      changeNewPrice(value) {
        if(value==''||value==undefined) {
          return;
        }
        this.newPriceInfo=this.userPriceList.find(item => item.id === value)
      },
      changeOldPrice(value) {
        if(value==''||value==undefined) {
          return;
        }
        this.oldPriceInfo=this.userPriceList.find(item => item.id === value)
      },
      onSearchArea(){
        this.$refs.areaWindow.add(this.checkedAreaKeys,this.halfCheckedAreaKeys,this.treeData,this.checkedAreaNames,this.userId);
      },
      modalAreaFormOk (formData) {
        this.checkedAreaNames = formData.areaNameList;
        this.checkedAreaNameString = this.checkedAreaNames.join(",");
        this.checkedAreaKeys = formData.checkedKeys;
        this.halfCheckedAreaKeys = formData.halfCheckedKeys;
      },
      queryAreaTree(){
        queryAreaTreeList().then((res)=>{
          // 过滤出 leaf node 即可，即选中的
          // Tree组件中checkStrictly默认为false的时候，选中子节点，父节点会自动设置选中或半选中
          // 保存 checkedKeys 以及 halfCheckedKeys 以便于未做任何操作时提交表单数据
          if(res.success){
            this.treeData = res.result;
          }
        })
      },
      convertTreeListToKeyLeafPairs(treeList, keyLeafPair = []) {
        for(const {key, leaf, children} of treeList) {
          keyLeafPair.push({key, leaf})
          if(children && children.length > 0) {
            this.convertTreeListToKeyLeafPairs(children, keyLeafPair)
          }
        }
        return keyLeafPair;
      },
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
.span {
  margin: 8px;
}
.background{
  background-color:rgb(238,238,238)
}
.detail-list >>> .content{
  line-height: normal;
}
.form-contain{
  height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.form-contain >>> .ant-divider-inner-text{
  color: rgba(24,144,255,0.85);
  font-size: 18px;
  font-weight: bold;
}
</style>